//  后端接口地址
let baseUrl = 'https://unicornsvc.aiyechen.com'
export default baseUrl;



// WEBPACK FOOTER //
// ./src/utils/setting.js